export enum ButtonType {
    LINK,
    BUTTON,
}

export enum ButtonSize {
    CAROUSEL,
    LARGE,
    MEDIUM,
    SMALL,
}

export enum ButtonColor {
    BLUE,
    CYAN,
}
